import makeGlobal from "../utils/makeGlobal";
var initialState = {
    message: "",
    severity: "info",
};
var actions = {
    setMessage: function (store) { return function (message) {
        return store.setState({
            message: message,
            severity: "info",
        });
    }; },
    setSnackBar: function (store) { return function (_a) {
        var message = _a.message, severity = _a.severity;
        return store.setState({ message: message, severity: severity });
    }; },
};
var useSnackbar = makeGlobal(initialState, actions);
export default useSnackbar;
//# sourceMappingURL=useSnackbar.js.map